import React from "react";

import { useTheme } from "@/hooks/useTheme";
import { useFela } from "react-fela";
import { Icon, StyledIconWrapper } from "@/components/Icon";
import { ILegendItem } from "../types";

interface IConverterFeaturesTab {
  legend: ILegendItem[];
}

export const ConverterFeaturesLegend: React.FC<IConverterFeaturesTab> = ({
  legend,
}) => {
  const { colors } = useTheme();
  const { css } = useFela();

  return (
    <div
      className={css({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 40,
        fontSize: 14,
        lineHeight: "22px",
        color: colors.DARK_GREY,
        flexWrap: "wrap",
      })}
    >
      {legend.map(({ icon, label }, index) => (
        <div key={index} className={css({ display: "flex", marginBottom: 10 })}>
          <StyledIconWrapper
            wrapperStyle={{
              width: 16,
              height: 16,
              marginRight: 8,
              flexShrink: 0,
              lineHeight: "16px",
            }}
            customStyle={{
              stroke:
                label === "Full Support"
                  ? colors.GRADIENT_BLUE_DARK
                  : "initial",
            }}
          >
            <Icon iconType={icon} />
          </StyledIconWrapper>
          {label}
        </div>
      ))}
    </div>
  );
};
